import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useCallback } from 'react';
import PT from 'prop-types';
import { Transition } from 'react-transition-group';
import { u as useModal } from '../Modal/useModalBehaviors-227d4d37.js';
import { O as Overlay } from './Overlay-98e3955e.js';
import { P as Portal } from '../Portal/Portal-4e001035.js';
import { a as TaktIdProvider } from '../TaktIdContext/TaktIdContext-f853b17a.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-39f30e88.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-ea7cc233-62dc80e0.js';

const SecondaryView = props => {
  const closeButtonRef = useRef(null);
  const containerRef = useRef(null);
  const fadeDuration = 150;
  const {
    children,
    closeButtonLabel,
    closeButtonProps,
    isOpen,
    onClose,
    padding = 'base',
    secondaryViewElementId,
    toggleEl,
    taktId,
    taktValue,
    ...rest
  } = props;
  const {
    handleKeyUp,
    handleKeyDown,
    handleFocusOnExit,
    handleFocusOnEnter
  } = useModal({
    initialRef: containerRef,
    onClose,
    triggerRef: toggleEl,
    firstRef: closeButtonRef
  });
  const teardown = useCallback(() => {
    handleFocusOnExit();
  }, [handleFocusOnExit]);
  return /*#__PURE__*/React__default.createElement(Transition, {
    timeout: fadeDuration,
    appear: true,
    in: isOpen,
    onExit: teardown,
    onEntered: handleFocusOnEnter,
    nodeRef: containerRef
  }, transitionState => {
    if (transitionState === 'exited') return null;
    return /*#__PURE__*/React__default.createElement(Portal, {
      containerId: secondaryViewElementId
    }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('secondary-view')
    }, /*#__PURE__*/React__default.createElement(Overlay, _extends({}, rest, {
      closeButtonProps: closeButtonProps,
      fadeDuration: fadeDuration,
      transitionState: transitionState,
      handleKeyDown: handleKeyDown,
      handleKeyUp: handleKeyUp,
      containerRef: containerRef,
      onClose: onClose,
      closeButtonRef: closeButtonRef,
      closeButtonLabel: closeButtonLabel,
      padding: padding
    }), children)));
  });
};
SecondaryView.propTypes = {
  /**
   * The React nodes/nodes that are rendered as content of the SecondaryView.
   */
  children: PT.node.isRequired,
  /**
   * Accepts elements to be rendered inside the close button in the header.
   */
  closeButtonLabel: PT.node,
  /**
   * Props that are applied to the CloseButton component.
   */
  closeButtonProps: PT.objectOf(PT.any),
  /**
   * Control open / close of secondary view. It will animate automatically on change.
   */
  isOpen: PT.bool,
  /**
   * Fired when any close action occurs such as; hitting the close button, or hitting escape.
   */
  onClose: PT.func,
  /**
   * Sets the padding around the secondary view's content.
   */
  padding: PT.oneOf(['none', 'micro', 'mini', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge']),
  /**
   * This should correspond to the ROOT level dom node id that the modal will render into.
   * When this prop is not explicitly passed a value, the secondary view will mount into the
   * div with id matching the portalElementId property in the popover object of the theme.
   */
  secondaryViewElementId: PT.string,
  /**
   * Pass a ref to an element here to use as the toggle element. Focus will move back to this
   * element when the bottom sheet closes.
   */
  toggleEl: PT.shape({
    current: PT.instanceOf(typeof Element !== 'undefined' ? Element : Object)
  })
};
SecondaryView.defaultProps = {
  closeButtonLabel: 'Done',
  closeButtonProps: undefined,
  isOpen: false,
  onClose: noop,
  padding: 'base',
  secondaryViewElementId: undefined,
  toggleEl: undefined
};
var SecondaryView$1 = SecondaryView;

export { SecondaryView$1 as S };
//# sourceMappingURL=SecondaryView-32dafb27.js.map
